import { render, staticRenderFns } from "./midwayWood.vue?vue&type=template&id=50cb5853&scoped=true&"
import script from "./midwayWood.vue?vue&type=script&lang=js&"
export * from "./midwayWood.vue?vue&type=script&lang=js&"
import style0 from "./midwayWood.vue?vue&type=style&index=0&id=50cb5853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cb5853",
  null
  
)

export default component.exports